import {MediaQuery} from '@constants/theme';
import {AutocompleteGetTagProps, BoxProps, SvgIcon} from '@mui/material';
import MuiBox from '@new-components/atoms/MuiBox';
import MuiTypography from '@new-components/atoms/MuiTypography';

interface ChipProps extends ReturnType<AutocompleteGetTagProps> {
  label: string;
  maxWidth?: string;
  component?: BoxProps['component'];
  sx?: BoxProps['sx'];
}
export function Chip(props: ChipProps) {
  return (
    <MuiBox
      id={`${props.label}-tag`}
      component={props.component}
      sx={{
        background: '#FFE4D6',
        padding: '4px 8px',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        borderRadius: '8px',
        width: 'fit-content',
        boxSizing: 'border-box',
        height: '30px',
        ...(props.sx ?? {}),
      }}>
      <MuiTypography
        sx={{
          fontSize: '17px',
          fontWeight: 400,
          lineHeight: '23.8px',
          letterSpacing: '-0.4000000059604645px',
          textAlign: 'left',
          textUnderlinePosition: 'from-font',
          textDecorationSkipInk: 'none',
          color: '#D55917',
          maxWidth: props.maxWidth ? props.maxWidth : 'none',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          [MediaQuery.mobile]: {
            maxWidth: '40px',
            fontSize: '14px',
          },
        }}>
        {props.label}
      </MuiTypography>
      <SvgIcon
        id='remove-tag'
        sx={{width: '12px', height: '12px', opacity: 0.5, cursor: 'pointer'}}
        onClick={props.onDelete}>
        <svg
          width='10'
          height='10'
          viewBox='0 0 10 10'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M8.5 1.5L1.5 8.5M1.5 1.5L8.5 8.5'
            stroke='#D55917'
            strokeWidth='1.25'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </SvgIcon>
    </MuiBox>
  );
}
